import { useQuery } from '@tanstack/react-query';
import Api, { withAcl } from 'hooks/Api';
import { useProvider } from 'utils/providers/Provider';
import { useAdminParams } from 'utils/helpers';
import { ApiError, Meta, ViewData } from 'utils/types';

import c from '../utils/constants';

interface Result {
  data: ViewData[];
  meta: Meta;
}

export default function useGetViewDatas(
  params: Pick<ViewData, 'type' | 'source'> & Partial<Meta>,
) {
  const { state } = useProvider();
  const args = state;
  const { accountId, accountUserId } = useAdminParams();

  return useQuery<Result, ApiError>({
    queryKey: [c.VIEW_DATAS, params],
    queryFn: async () => {
      const api = new Api(args);

      const data = await api.get(
        await withAcl({
          account: {
            url: `/api/v3/views/data`,
            params,
          },
          admin: {
            url: `/api/v2/accounts/${accountId}/users/${accountUserId}/views/data`,
            params,
          },
        }),
      );

      return data;
    },
  });
}
